import { NgModule } from '@angular/core';

import { SharedModule } from "../shared/shared.module";
import { MedidasModule } from "./medidas/medidas.module";
import { MateriaisModule } from "./materiais/materiais.module";
import { AlmoxarifadoComponent } from "./almoxarifado.component";
import { AlmoxarifadoRoutingModule } from "./almoxarifado-routing.module";
import { GruposMateriaisModule } from "./grupos-materiais/grupos-materiais.module";

@NgModule({
    imports: [
        SharedModule,
        MedidasModule,
        MateriaisModule,
        GruposMateriaisModule,
        AlmoxarifadoRoutingModule
    ],
    declarations: [
        AlmoxarifadoComponent
    ]
})
export class AlmoxarifadoModule { }



/** WEBPACK FOOTER **
 ** ./~/angular2-template-loader!./src/app/almoxarifado/almoxarifado.module.ts
 **/